/** Ascending or descending sort direction. */
export enum DirectionEnum {
  asc = 'asc',
  desc = 'desc',
}
